"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleCountry = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let SimpleCountry = class SimpleCountry {
    _id;
    isoCode = "";
    englishName = "";
    pricingCurrency = legacy_enums_1.Currency.Euro;
    timeZoneName = "";
    callingCode = "";
    bankType = legacy_enums_1.CountryBankType.IBAN;
    invoiceInfo = null;
    vehicleTypeCosts = [];
};
exports.SimpleCountry = SimpleCountry;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleCountry.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(16),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleCountry.prototype, "isoCode", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleCountry.prototype, "englishName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SimpleCountry.prototype, "pricingCurrency", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleCountry.prototype, "timeZoneName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleCountry.prototype, "callingCode", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.CountryBankType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SimpleCountry.prototype, "bankType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SimpleCountry.prototype, "invoiceInfo", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SimpleCountry.prototype, "vehicleTypeCosts", void 0);
exports.SimpleCountry = SimpleCountry = __decorate([
    (0, class_transformer_1.Exclude)()
], SimpleCountry);
//# sourceMappingURL=SimpleCountry.js.map